
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import IconAction from '@/components/IconAction/IconAction.vue'
import Widget from '@/components/Widget/Widget.vue'
import ViewModel from '@/models/ViewModel'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import AudienceSegmentsModule from '@/models/AudienceSegments'
import DropArea from '@/components/DropArea/DropArea.vue'

import ModelFileUploader from '@/components/ModelFile/ModelFileUploader.vue'
import audienceSegmentFeilds from './audience-segment-feilds'

@Component({
  components: {
    IconAction,
    Widget,
    SearchInput,
    DataTable,
    DropArea,
    ModelFileUploader,
  },
})
export default class AudienceSegmentHome extends ViewModel {
  @Ref() readonly dataTable!: DataTable

  public ready: boolean = false

  public query: string = ''

  public query_settings: any = {
    placeholder: 'Search',
    icon: 'search',
    size: 'sm',
    class: 'w-100',
  }

  public show_filter_helper: boolean = false

  public filter_mode: string = 'all'

  public page: number = 1

  public records: number = 0

  public all_fields: any[] = []

  public selected: any[] = []

  public fieldFilters: any = {}

  public reload_drop_down_area: boolean = false

  public imported_file_row_keys: any = null

  public loaded_data: any = []

  public import_status: string = ''

  public import_errors: any = []

  public import_error_type: string = 'warning'

  public failed_import: boolean = false

  public file_name: string = ''

  public import_modal: boolean = false

  public audience_segment: AudienceSegmentsModule = new AudienceSegmentsModule()

  @Watch('import_modal')
  public onImportModalChange(val: boolean) {
    if (!val) {
      this.audience_segment = new AudienceSegmentsModule()
      this.import_status = ''
      this.import_errors = []
      this.failed_import = false
      this.file_name = ''
    }
  }

  @Watch('query')
  public onQueryChange() {
    if (this.dataTable) {
      this.dataTable.page = this.page
    }
  }

  @Watch('filter_mode')
  public onFilterModeChange() {
    if (this.dataTable) {
      this.dataTable.page = this.page
    }
    this.refresh()
  }

  public get fields() {
    return this.all_fields.filter(field => field.show)
  }

  mounted() {
    this.all_fields = audienceSegmentFeilds
    this.loadFilters()
    this.ready = true
  }

  get segments() {
    return []
  }

  public refresh() {}

  public resetFilters() {}

  public async audienceSegments(ctx: any) {
    this.loading = true
    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)

    this.syncFilters()

    return AudienceSegmentsModule.paginate({
      page_size: ctx.perPage,
      page: ctx.currentPage,
      order_by: ctx.sortBy,
      order: ctx.sortDesc ? 'desc' : 'asc',
      query: [...ctx.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.records = result.records
      this.selected = []
      this.loading = false
      this.ready = true
      return result.data
    })
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'audience_segment',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('audience_segment').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'audience_segment',
      data: null,
    })
  }

  public importMarket() {
    this.import_status = 'Uploading...'

    this.audience_segment
      .importLiverampCatalog()
      .then(() => {
        this.import_status = 'Import successful!'
      })
      .catch(() => {
        this.import_status = 'Import failed.'
      })
      .finally(() => {
        this.import_modal = false
        this.import_status = ''
      })
  }

  public formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
  }
}
